




















































import Vue from 'vue';
import { mapState } from 'vuex';
import { errorToMessage } from '@/core/utils/errors';
import { replaceRedirectURLWithCurrentDomain } from '@/web/utils/url';

export default Vue.extend({
  name: 'StripeIntegration',
  props: {
    returnUrl: {
      type: String,
      default: process.env.VUE_APP_STRIPE_REDIRECT_URL,
    },
  },
  computed: {
    ...mapState('setting', ['currencies']),
    isStripeConnected() {
      if (!this.paymentInfo) return false;

      return this.paymentInfo.stripe_secret_key;
    },
    hasStripeConnectAccount() {
      return !!this.paymentInfo?.stripe_user_id;
    },
  },
  data() {
    return {
      logo: '/assets/images/integrations/stripe@3x.png',
      paymentInfo: null,
      selectedCurrency: null,
      isLoading: true,
      inProgress: false,
    };
  },
  methods: {
    getConnectStripeURL() {
      const redirectURL = encodeURIComponent(
        replaceRedirectURLWithCurrentDomain(this.returnUrl)
      );
      const clientId = process.env.VUE_APP_STRIPE_CLIENT_ID;
      return `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${clientId}&scope=read_write&redirect_uri=${redirectURL}`;
    },
    async checkForStripeOAuthCode() {
      const code = this.$route.query.code;
      if (!code) return;
      await this.connectStripe(code);
      const query = { ...this.$route.query };
      delete query.code;
      this.$router.replace({ query });
    },
    async connectStripe(code) {
      try {
        this.paymentInfo = await this.$store.dispatch(
          'setting/connectStripe',
          code
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to connect Stripe',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1,
        });
      }
    },
    async disconnectStripe(code) {
      try {
        this.paymentInfo = await this.$store.dispatch(
          'setting/disconnectStripe',
          code
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to disconnect Stripe',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1,
        });
      }
    },
    async selectCurrency(currency) {
      this.selectedCurrency = currency;
      const currencyCode = currency?.code;
      try {
        await this.$store.dispatch('setting/updateCurrency', currencyCode);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('SETTINGS.NOTIFICATIONS.CURRENCY_SUCCESSFULLY_UPDATED'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to update currency',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
  },
  async mounted() {
    const [paymentInfo, currencies] = await Promise.all([
      this.$store.dispatch('setting/getPaymentInfo'),
      this.$store.dispatch('setting/getCurrencies', 'stripe'),
    ]);
    this.paymentInfo = paymentInfo;

    this.selectedCurrency = this.currencies.find(
      ({ code }) => code === this.paymentInfo.currency
    );

    this.isLoading = false;
    this.checkForStripeOAuthCode();
  },
});
